<template>
    <b-card no-body class="overflow-hidden" style="max-width: 540px;">
        <b-row>
            <b-col>
                <b-img 
                    :src="imgSrc"
                    fluid
                />
            </b-col>
        </b-row>
        <b-row class="my-2">
            <b-col>
                <center class="font-weight-bold">
                    {{text}}
                </center>
            </b-col>
        </b-row>
    </b-card>
</template>

<style scoped>

</style>

<script>
export default {
    props: {
        imgSrc: {
            type: String
        },
        text: {
            type: String
        }
    },
    data() {
        return {
            
        }
    },
    methods: {

    },
    mounted() {

    }
}
</script>